/**
 * Frontend mirror of backend CommissionProvisionType (cn/enums/CommissionProvisionType.java).
 *
 * Ordinal order MUST match the backend declaration exactly — ordinals are stored in the DB
 * and must never change.
 *
 * GDV codes (informational):
 *   ACQUISITION    → GDV 1  (AP  — Abschlussprovision)
 *   COLLECTION     → GDV 2  (Inkassoprovision)
 *   RENEWAL        → GDV 3  (VLP — Verlängerungsprovision)
 *   LEADERSHIP     → GDV 4  (Führungsprovision)
 *   OTHER          → GDV 5  (Sonstige / Überweisungsprovision / Sonderbonifikation)
 *   BROKERAGE      → GDV 6  (Courtage / Maklercourtage)
 *   PORTFOLIO_CARE → GDV 7  (BP  — Bestandspflegeprovision)
 */
export enum CommissionProvisionTypeEnum {
    ACQUISITION,
    COLLECTION,
    RENEWAL,
    LEADERSHIP,
    OTHER,
    BROKERAGE,
    PORTFOLIO_CARE,
}
